module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAvUlEQVR4nNWUQQrCMBBF48LLeAhXeoD/S8GF657FtR7Brd5OpMkIkaCCtLHNmHTRD9nNf/nMJGPMrOWNWVjyaIGdxifkxgFn3zTLOBQ4OdJb4GGrap8CdeTaArfgc+S1B2/remWB+7vgBR9JHpJ2PeGisdv9UHJNbbJBDU0x/g39SIBtr+fkQTuHqLrpvo86aQo8GxprSRGwRKDZcJlieBKD5j43GYBO+uvUte1US8iXWJvA5fdOZuFFPxs9AbkXp62sv7RDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icons8-close-22.png
// module id = OI/u
// module chunks = 0